import React from 'react';
import { usePermission } from '../../context/PermissionContext';

/**
 * Conditionally renders children based on permissions.
 * @param {string} scope - 'global' or 'project'
 * @param {string} permission - e.g. 'journal.create'
 * @param {React.ReactNode} children - Content to show if allowed
 * @param {React.ReactNode} fallback - Content to show if denied (optional)
 */
const PermissionGuard = ({ scope, permission, children, fallback = null }) => {
    const { can } = usePermission();

    if (can(scope, permission)) {
        return <>{children}</>;
    }

    return fallback;
};

export default PermissionGuard;
